import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class DetailViewEnteredMessage extends Message {

    public hasServerError: boolean;
    public isPushed: boolean;
    public isSummaryViewMode: boolean;
    public isModalDetailView: boolean;

    public constructor(params: any) {
        super(params);

        this.hasServerError = this.paramOrDefault(params.hasServerError, false);
        this.isPushed = this.paramOrDefault(params.isPushed, false);
        this.isSummaryViewMode = this.paramOrDefault(params.isSummaryViewMode, false);
        this.isModalDetailView = this.paramOrDefault(params.isModalDetailView, false);
    }
}

ComponentManager.setMessage('DetailViewEnteredMessage', DetailViewEnteredMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');